import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { ScreenReaderText } from '#/shared/components/Accessibility';
import useIntlDatetime from '#/shared/hooks/useIntlDatetime';
import GTM_HANDLES from '#/shared/gtm-handles';
import * as Styled from './styled';

const { TimestampRefreshWrapper } = Styled;

function TimestampRefreshButton({ timestamp, onClick, className }) {
  const { milliSecondsToTriMetTimeString } = useIntlDatetime();
  const intl = useIntl();

  return (
    <Styled.RefreshButton
      onClick={onClick}
      title={intl.formatMessage({ id: 'nearbystops.refresh-arrivals-tip' })}
      // the component is used a few places, but clicks are intentionally
      // aggregated for all instances in Google Analytics
      data-gtm={GTM_HANDLES.shared.trackerRefreshButton}
      className={className}
    >
      <Styled.RefreshIcon
        role="img"
        aria-hidden="true"
        data-testid="refresh-icon"
      />
      <ScreenReaderText>
        <FormattedMessage id="nearbystops.refresh-arrivals-a11y" />
      </ScreenReaderText>
      <Styled.RefreshTime>
        {milliSecondsToTriMetTimeString(timestamp || Date.now())}
      </Styled.RefreshTime>
    </Styled.RefreshButton>
  );
}

TimestampRefreshButton.propTypes = {
  timestamp: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

TimestampRefreshButton.defaultProps = {
  timestamp: null,
  className: null,
};

export default TimestampRefreshButton;
export { TimestampRefreshWrapper };
